// import React, {useEffect} from 'react';
// import {Calendar, DollarSign, Edit, Eye, Mail, MapPin, Package, Phone, TrendingUp, User, X} from "lucide-react";
// import {useManageClients} from "../../useManageClients";
// import {format} from "date-fns";
//
// const ViewClientModal = ({onClose,selectedClient}:any) => {
//     const {
//         setShowViewModal,
//         handleViewClient,
//         formatCurrency,
//         // handleSaveClient,
//         handleCancelEdit,
//         setEditMode,
//         editMode,
//         editingClient,
//         setEditingClient,
//         getClientVisits,
//         handleCloseViewClient,
//         onUserUpdate
//
//     }=useManageClients()
//
//
//     const handleSaveClient = async () => {
//         if (!editingClient) return;
//
//         const updatedClient = {
//             ...selectedClient,
//             name: `${editingClient.firstName} ${editingClient.lastName}`.trim(),
//             email: editingClient.email,
//             phone: editingClient.phone,
//             notes: editingClient.notes
//                 ? editingClient.notes.split("\n").map((line:any, i:any) => ({
//                     id: selectedClient.notes[i]?.id || `temp-${i}`,
//                     content: line,
//                     createdBy: selectedClient.notes[i]?.createdBy,
//                     noteable: selectedClient.notes[i]?.noteable,
//                     createdAt: selectedClient.notes[i]?.createdAt || new Date().toISOString(),
//                     updatedAt: new Date().toISOString(),
//                 }))
//                 : [],
//         };
//
//        await onUserUpdate(updatedClient);
//         setEditMode(false);
//     };
//
//
//
//
//     // showViewModal selectedClient
//
//     useEffect(() => {
//
//
//         console.log('seleceted in modal',selectedClient)
//
//
//     }, [selectedClient]);
//
//
//
//     return (
//             <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//                 <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl mx-4 max-h-[85vh] overflow-y-auto">
//                     {/* Header Section */}
//                     <div className="p-4 border-b border-gray-200">
//                         <div className="flex items-center justify-between">
//                             <div className="flex items-center space-x-2">
//                                 <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center shadow-md">
//                                     <User className="h-6 w-6 text-white" />
//                                 </div>
//                                 <div>
//                                     <h3 className="text-xl font-bold text-gray-900"> {selectedClient?.name}</h3>
//                                     <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 mt-1">
//                       Standard Client
//                     </span>
//                                 </div>
//                             </div>
//                             <div className="flex items-center space-x-2">
//                                 <button
//                                     // onClick={handleCloseViewClient}
//                                     // onClick={()=>setShowView(false)}
//                                     onClick={onClose}
//                                     className="p-2 hover:bg-gray-100 rounded-full transition-colors"
//                                 >
//                                     <X className="h-4 w-4 text-gray-400" />
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//
//                     {/* Stats Section */}
//                     <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
//                         <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
//                             <div className="bg-white p-3 rounded-lg border border-gray-200 shadow-sm">
//                                 <div className="flex items-center space-x-2">
//                                     <div className="p-1.5 bg-green-100 rounded-md">
//                                         <DollarSign className="h-4 w-4 text-green-600" />
//                                     </div>
//                                     <div>
//                                         <p className="text-xs font-medium text-gray-600">Total Spent</p>
//                                         <p className="text-lg font-bold text-green-600">{formatCurrency(selectedClient?.totalSpent||0)}</p>
//                                     </div>
//                                 </div>
//                             </div>
//
//                             <div className="bg-white p-3 rounded-lg border border-gray-200 shadow-sm">
//                                 <div className="flex items-center space-x-2">
//                                     <div className="p-1.5 bg-blue-100 rounded-md">
//                                         <TrendingUp className="h-4 w-4 text-blue-600" />
//                                     </div>
//                                     <div>
//                                         <p className="text-xs font-medium text-gray-600">Total Visits</p>
//                                         <p className="text-lg font-bold text-blue-600">{selectedClient?.visits || 0}</p>
//                                     </div>
//                                 </div>
//                             </div>
//
//                             <div className="bg-white p-3 rounded-lg border border-gray-200 shadow-sm">
//                                 <div className="flex items-center space-x-2">
//                                     <div className="p-1.5 bg-purple-100 rounded-md">
//                                         <Calendar className="h-4 w-4 text-purple-600" />
//                                     </div>
//                                     <div>
//                                         <p className="text-xs font-medium text-gray-600">Last Visit</p>
//                                         <p className="text-sm font-semibold text-gray-900">
//                                             {selectedClient?.lastVisit ? new Date(selectedClient?.lastVisit).toLocaleDateString('en-US', {
//                                                 year: 'numeric',
//                                                 month: '2-digit',
//                                                 day: '2-digit'
//                                             }) : 'Never'}
//                                         </p>
//                                     </div>
//                                 </div>
//                             </div>
//
//                             <div className="bg-white p-3 rounded-lg border border-gray-200 shadow-sm">
//                                 <div className="flex items-center space-x-2">
//                                     <div className="p-1.5 bg-orange-100 rounded-md">
//                                         <User className="h-4 w-4 text-orange-600" />
//                                     </div>
//                                     <div>
//                                         <p className="text-xs font-medium text-gray-600">Client Since</p>
//                                         <p className="text-sm font-semibold text-gray-900">
//                                             {format(selectedClient?.createdAt, "MM/dd/yyyy")}
//                                         </p>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//
//                     {/* Main Content */}
//                     <div className="p-4">
//                         <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
//                             {/* Left Column - Personal Information */}
//                             <div className="lg:col-span-2">
//                                 <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
//                                     <div className="p-4">
//                                         <div className="flex items-center justify-between mb-4">
//                                             <h4 className="text-base font-semibold text-blue-600 flex items-center">
//                                                 <User className="h-4 w-4 text-blue-600 mr-2" />
//                                                 Personal Information
//                                             </h4>
//                                             {editMode ? (
//                                                 <div className="flex items-center space-x-2">
//                                                     <button
//                                                         onClick={handleSaveClient}
//                                                         className="px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-all duration-200 text-sm font-medium shadow-sm"
//                                                     >
//                                                         Save Changes
//                                                     </button>
//                                                     <button
//                                                         onClick={handleCancelEdit}
//                                                         className="px-3 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-all duration-200 text-sm font-medium"
//                                                     >
//                                                         Cancel
//                                                     </button>
//                                                 </div>
//                                             ) : (
//                                                 <button
//                                                     onClick={() => {
//                                                         setEditMode(true);
//                                                         setEditingClient({
//                                                             id: selectedClient.id,
//                                                             firstName: selectedClient.name.split(" ")[0] || "",
//                                                             lastName: selectedClient.name.split(" ")[1] || "",
//                                                             email: selectedClient.email || "",
//                                                             phone: selectedClient.phone || "",
//                                                             notes: selectedClient.notes?.map((n:any) => n.content).join("\n") || ""
//                                                         });
//                                                     }}
//
//
//                                                     // onClick={() => {
//
//
//                                                         // setEditMode(true)
//                                                         // setEditingClient(selectedClient)
//                                                  //   }}
//                                                     className="flex items-center space-x-2 px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-all duration-200 text-sm font-medium shadow-sm"
//                                                 >
//                                                     <Edit className="h-4 w-4" />
//                                                     <span>Edit</span>
//                                                 </button>
//                                             )}
//                                         </div>
//
//                                         {/* Name Section */}
//                                         <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//                                             <div>
//                                                 <label className="block text-sm font-medium text-gray-700 mb-2">First Name</label>
//                                                 {editMode ? (
//                                                     <input
//                                                         type="text"
//                                                         // defaultValue={selectedClient.name.split(" ")[0]}
//                                                         value={selectedClient?.name.split(" ")[0] || ''}
//                                                         onChange={(e) => setEditingClient((prev:any) => prev ? {...prev, firstName: e.target.value} : null)}
//                                                         className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
//                                                     />
//                                                 ) : (
//                                                     <div className="px-3 py-2 bg-gray-50 rounded-md border border-gray-200">
//                                                         <span className="text-gray-900 font-medium">{selectedClient.name.split(" ")[0]}</span>
//                                                     </div>
//                                                 )}
//                                             </div>
//
//                                             <div>
//                                                 <label className="block text-sm font-medium text-gray-700 mb-2">Last Name</label>
//                                                 {editMode ? (
//                                                     <input
//                                                         type="text"
//                                                         value={selectedClient.name.split(" ")[1] || ''}
//                                                         onChange={(e) => setEditingClient((prev:any) => prev ? {...prev, lastName: e.target.value} : null)}
//                                                         className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
//                                                     />
//                                                 ) : (
//                                                     <div className="px-3 py-2 bg-gray-50 rounded-md border border-gray-200">
//                                                         <span className="text-gray-900 font-medium">{selectedClient.name.split(" ")[1]}</span>
//                                                     </div>
//                                                 )}
//                                             </div>
//                                         </div>
//
//                                         {/* Contact Section */}
//                                         <div className="mb-4">
//                                             <h5 className="text-sm font-medium text-blue-600 mb-3 flex items-center">
//                                                 <Phone className="h-4 w-4 text-blue-600 mr-2" />
//                                                 Contact Information
//                                             </h5>
//                                             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                                                 <div>
//                                                     <label className="block text-sm font-medium text-gray-700 mb-2">Email Address</label>
//                                                     {editMode ? (
//                                                         <input
//                                                             type="email"
//                                                             value={selectedClient?.email || ''}
//                                                             onChange={(e) => setEditingClient((prev:any) => prev ? {...prev, email: e.target.value} : null)}
//                                                             className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
//                                                         />
//                                                     ) : (
//                                                         <div className="flex items-center px-3 py-2 bg-gray-50 rounded-md border border-gray-200">
//                                                             <Mail className="h-4 w-4 text-gray-400 mr-2" />
//                                                             <span className="text-gray-900">{selectedClient?.email}</span>
//                                                         </div>
//                                                     )}
//                                                 </div>
//
//                                                 <div>
//                                                     <label className="block text-sm font-medium text-gray-700 mb-2">Phone Number</label>
//                                                     {editMode ? (
//                                                         <input
//                                                             type="tel"
//                                                             value={selectedClient?.phone || ''}
//                                                             onChange={(e) => setEditingClient((prev:any) => prev ? {...prev, phone: e.target.value} : null)}
//                                                             className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
//                                                         />
//                                                     ) : (
//                                                         <div className="flex items-center px-3 py-2 bg-gray-50 rounded-md border border-gray-200">
//                                                             <Phone className="h-4 w-4 text-gray-400 mr-2" />
//                                                             <span className="text-gray-900">{selectedClient?.phone}</span>
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             </div>
//                                         </div>
//
//                                         {/* Birthday Section */}
//                             {/*            <div className="mb-4">*/}
//                             {/*                <label className="block text-sm font-medium text-gray-700 mb-2">Date of Birth</label>*/}
//                             {/*                {editMode ? (*/}
//                             {/*                    <input*/}
//                             {/*                        type="date"*/}
//                             {/*                        value={editingClient?.birthday || ''}*/}
//                             {/*                        onChange={(e) => setEditingClient((prev:any) => prev ? {...prev, birthday: e.target.value} : null)}*/}
//                             {/*                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"*/}
//                             {/*                    />*/}
//                             {/*                ) : (*/}
//                             {/*                    <div className="px-3 py-2 bg-gray-50 rounded-md border border-gray-200">*/}
//                             {/*<span className="text-gray-900">*/}
//                             {/*  {selectedClient?.birthday*/}
//                             {/*      ? new Date(selectedClient?.birthday).toLocaleDateString('en-US', {*/}
//                             {/*          year: 'numeric',*/}
//                             {/*          month: '2-digit',*/}
//                             {/*          day: '2-digit'*/}
//                             {/*      })*/}
//                             {/*      : 'Not provided'*/}
//                             {/*  }*/}
//                             {/*</span>*/}
//                             {/*                    </div>*/}
//                             {/*                )}*/}
//                             {/*            </div>*/}
//
//                                         {/* Address Section */}
//                                         {/*<div className="mb-4">*/}
//                                         {/*    <h5 className="text-sm font-medium text-blue-600 mb-3 flex items-center">*/}
//                                         {/*        <MapPin className="h-4 w-4 text-blue-600 mr-2" />*/}
//                                         {/*        Address*/}
//                                         {/*    </h5>*/}
//                                         {/*    <div className="space-y-3">*/}
//                                         {/*        <div>*/}
//                                         {/*            <label className="block text-sm font-medium text-gray-700 mb-2">Street Address</label>*/}
//                                         {/*            {editMode ? (*/}
//                                         {/*                <input*/}
//                                         {/*                    type="text"*/}
//                                         {/*                    value={editingClient?.street || ''}*/}
//                                         {/*                    onChange={(e) => setEditingClient((prev:any) => prev ? {...prev, street: e.target.value} : null)}*/}
//                                         {/*                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"*/}
//                                         {/*                />*/}
//                                         {/*            ) : (*/}
//                                         {/*                <div className="px-3 py-2 bg-gray-50 rounded-md border border-gray-200">*/}
//                                         {/*                    <span className="text-gray-900">{selectedClient?.street}</span>*/}
//                                         {/*                </div>*/}
//                                         {/*            )}*/}
//                                         {/*        </div>*/}
//
//                                         {/*        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">*/}
//                                         {/*            <div>*/}
//                                         {/*                <label className="block text-sm font-medium text-gray-700 mb-2">City</label>*/}
//                                         {/*                {editMode ? (*/}
//                                         {/*                    <input*/}
//                                         {/*                        type="text"*/}
//                                         {/*                        value={editingClient?.city || ''}*/}
//                                         {/*                        onChange={(e) => setEditingClient((prev:any) => prev ? {...prev, city: e.target.value} : null)}*/}
//                                         {/*                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"*/}
//                                         {/*                    />*/}
//                                         {/*                ) : (*/}
//                                         {/*                    <div className="px-3 py-2 bg-gray-50 rounded-md border border-gray-200">*/}
//                                         {/*                        <span className="text-gray-900">{selectedClient?.city}</span>*/}
//                                         {/*                    </div>*/}
//                                         {/*                )}*/}
//                                         {/*            </div>*/}
//
//                                         {/*            <div>*/}
//                                         {/*                <label className="block text-sm font-medium text-gray-700 mb-2">State</label>*/}
//                                         {/*                {editMode ? (*/}
//                                         {/*                    <input*/}
//                                         {/*                        type="text"*/}
//                                         {/*                        value={editingClient?.state || ''}*/}
//                                         {/*                        onChange={(e) => setEditingClient((prev:any) => prev ? {...prev, state: e.target.value} : null)}*/}
//                                         {/*                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"*/}
//                                         {/*                    />*/}
//                                         {/*                ) : (*/}
//                                         {/*                    <div className="px-3 py-2 bg-gray-50 rounded-md border border-gray-200">*/}
//                                         {/*                        <span className="text-gray-900">{selectedClient?.state}</span>*/}
//                                         {/*                    </div>*/}
//                                         {/*                )}*/}
//                                         {/*            </div>*/}
//
//                                         {/*            <div>*/}
//                                         {/*                <label className="block text-sm font-medium text-gray-700 mb-2">ZIP Code</label>*/}
//                                         {/*                {editMode ? (*/}
//                                         {/*                    <input*/}
//                                         {/*                        type="text"*/}
//                                         {/*                        value={editingClient?.zipCode || ''}*/}
//                                         {/*                        onChange={(e) => setEditingClient((prev:any) => prev ? {...prev, zipCode: e.target.value} : null)}*/}
//                                         {/*                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"*/}
//                                         {/*                    />*/}
//                                         {/*                ) : (*/}
//                                         {/*                    <div className="px-3 py-2 bg-gray-50 rounded-md border border-gray-200">*/}
//                                         {/*                        <span className="text-gray-900">{selectedClient?.zipCode}</span>*/}
//                                         {/*                    </div>*/}
//                                         {/*                )}*/}
//                                         {/*            </div>*/}
//                                         {/*        </div>*/}
//                                         {/*    </div>*/}
//                                         {/*</div>*/}
//
//                                         {/* Notes Section */}
//                                         <div>
//                                             <h5 className="text-sm font-medium text-blue-600 mb-3">Notes</h5>
//                                             <div>
//                                                 {editMode ? (
//                                                     <textarea
//                                                         rows={4}
//                                                         value={editingClient?.notes || ''}
//                                                         onChange={(e) => setEditingClient((prev:any) => prev ? {...prev, notes: e.target.value} : null)}
//                                                         className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 resize-none"
//                                                         placeholder="Add any special notes about this client..."
//                                                     />
//                                                 ) : (
//                                                     <div className="px-3 py-2 bg-gray-50 rounded-md border border-gray-200 min-h-[80px]">
//                                                         <p className="text-gray-900 whitespace-pre-wrap">
//                                                             {selectedClient.notes?.map((n:any) => n.content).join("\n") || "No notes available"}
//                                                         </p>
//                                                     </div>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//
//                             {/* Right Column - Order History */}
//                             <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
//                                 <div className="p-4">
//                                     <div className="flex items-center justify-between mb-6">
//                                         <h4 className="text-base font-semibold text-blue-600 flex items-center">
//                                             <Package className="h-4 w-4 text-blue-600 mr-2" />
//                                             Order History
//                                         </h4>
//                                         <button className="text-sm text-blue-600 hover:text-blue-700 font-medium transition-colors">
//                                             View All
//                                         </button>
//                                     </div>
//                                     <div className="space-y-3">
//                                         {/*{getClientVisits(selectedClient?.id)?.map((visit:any) => (*/}
//                                         {/*    <div key={visit.id} className="bg-gradient-to-r from-gray-50 to-gray-100 p-2 rounded-lg border border-gray-200 hover:shadow-md transition-all duration-200">*/}
//                                         {/*        <div className="flex justify-between items-start">*/}
//                                         {/*            <div>*/}
//                                         {/*                <h5 className="font-medium text-gray-900 text-xs">{visit.service}</h5>*/}
//                                         {/*                <div className="flex items-center space-x-2">*/}
//                                         {/*                    <Calendar className="h-3 w-3 text-gray-400" />*/}
//                                         {/*                    <p className="text-xs text-gray-600">*/}
//                                         {/*                        {new Date(visit.date).toLocaleDateString('en-US', {*/}
//                                         {/*                            year: 'numeric',*/}
//                                         {/*                            month: '2-digit',*/}
//                                         {/*                            day: '2-digit'*/}
//                                         {/*                        })}*/}
//                                         {/*                    </p>*/}
//                                         {/*                </div>*/}
//                                         {/*            </div>*/}
//                                         {/*            <div className="flex items-center space-x-2">*/}
//                                         {/*                <span className="text-sm font-bold text-green-600">{formatCurrency(visit.amount)}</span>*/}
//                                         {/*                <button*/}
//                                         {/*                    className="p-1 text-gray-400 hover:text-blue-600 transition-colors"*/}
//                                         {/*                >*/}
//                                         {/*                    <Eye className="h-3 w-3" />*/}
//                                         {/*                </button>*/}
//                                         {/*            </div>*/}
//                                         {/*        </div>*/}
//                                         {/*    </div>*/}
//                                         {/*))}*/}
//                                         {/*{getClientVisits(selectedClient?.id).length === 0 && (*/}
//                                         {/*    <div className="text-center py-8 bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg border-2 border-dashed border-gray-300">*/}
//                                         {/*        <Package className="h-12 w-12 text-gray-300 mx-auto mb-3" />*/}
//                                         {/*        <p className="text-gray-500 mb-4">No orders recorded yet</p>*/}
//                                         {/*        <button className="px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm font-medium">*/}
//                                         {/*            Add First Order*/}
//                                         {/*        </button>*/}
//                                         {/*    </div>*/}
//                                         {/*)}*/}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//
//     );
// };
//
// export default ViewClientModal;


import React, { useEffect, useState } from "react";
import { Calendar, DollarSign, Edit, Eye, Mail, Package, Phone, TrendingUp, User, X, } from "lucide-react";
import { useManageClients } from "../../useManageClients";
import { format } from "date-fns";
import Select from "react-select";
import { DatePicker } from "@nextui-org/react";
import { parseDate } from "@internationalized/date";
import { today, getLocalTimeZone, CalendarDate } from "@internationalized/date";
import http from "app/requests/axiosInstance";
import TransactionDetailsModal from "app/sales/components/transactionDetailsScreen/TransactionDetailsModal";
import { useNavigate } from "react-router-dom";
import { useQuery } from "app/utils/useQuery";
import { useSelector } from "react-redux";
import type { RootState } from "app/redux/store";
import { shopTimeZoneFromShops, toLocalDate } from "app/utils/timezone";


interface ViewClientModalProps {
    onClose: () => void;
    selectedClient: any;
}




const sampleVisits: any = [
    { id: 'v001', clientId: '0001', date: '2024-01-15', service: 'Hydrating Facial', amount: 150, notes: 'Great results' },
    { id: 'v002', clientId: '0001', date: '2024-01-01', service: 'Botox Treatment', amount: 400, notes: 'Touch-up needed in 4 months' },
    { id: 'v003', clientId: '0002', date: '2024-01-12', service: 'Laser Hair Removal', amount: 300, notes: 'Package session 3/6' },
    { id: 'v004', clientId: '0003', date: '2024-01-10', service: 'Chemical Peel', amount: 200, notes: 'Excellent healing' }
];



const ViewClientModal: React.FC<ViewClientModalProps> = ({
    onClose,
    selectedClient,
}) => {

    const {
        formatCurrency,
        isCreatingClient,
        setIsCreatingClient,
        profileImagePreview,
        setProfileImagePreview,
        profileImageFile,
        setProfileImageFile,
        handleAvatarUpload,
        handleProfileImageChange,
        updateClientBulk, // new function added to the hook
        employees,
    } = useManageClients();
    const shops = useSelector((state: RootState) => state.shops) as any[];
    const [sales, setSales] = useState<any[]>([]);
    const [isLoadingHistory, setIsLoadingHistory] = useState<boolean>(false);

    const query = useQuery();
    const navigate = useNavigate();
    const [selectedSaleId, setSelectedSaleId] = useState<number | null>(null);

    const handleOpenTransactionDetails = (saleId: number) => {
        query.set("saleId", saleId.toString());
        navigate(`${window.location.pathname}?${query.toString()}`);
        setSelectedSaleId(saleId);
    };

    const handleCloseTransactionDetails = () => {
        query.delete("saleId");
        navigate(`${window.location.pathname}?${query.toString()}`);
        setSelectedSaleId(null);
    };

    useEffect(() => {
        if (selectedClient?.id) {
            const fetchHistory = async () => {
                setIsLoadingHistory(true);
                try {
                    const res = await http.get(`/v1/sales?client_id=${selectedClient.id}&per_page=1000`);
                    setSales(res.data.sales || []);
                } catch (error) {
                    console.error("Error fetching client sales:", error);
                } finally {
                    setIsLoadingHistory(false);
                }
            };
            fetchHistory();
        } else {
            setSales([]);
        }
    }, [selectedClient?.id]);

    const [isEditing, setIsEditing] = useState(false);
    const [editingClient, setEditingClient] = useState<any | null>(null);

    useEffect(() => {
        // whenever selectedClient changes, if not editing, keep UI showing selectedClient
        if (!isEditing) setEditingClient(null);
    }, [selectedClient, isEditing]);

    const startEdit = () => {
        const nameParts = (selectedClient?.name || "").split(" ");
        setEditingClient({
            id: selectedClient.id,
            firstName: nameParts[0] || "",
            lastName: nameParts.slice(1).join(" ") || "",
            email: selectedClient.email || "",
            phone: selectedClient.phone || "",
            gender: selectedClient.gender || "non_binary",
            address: selectedClient.address,
            dob: selectedClient?.dob,
            notes: selectedClient.notes,
            // copy any other fields you want editable
        });
        setIsEditing(true);
    };

    const cancelEdit = () => {
        setIsEditing(false);
        setEditingClient(null);
    };



    const handleSave = async () => {
        if (!editingClient) return;
        await updateClientBulk(editingClient);
        // close edit mode and optionally refresh parent
        setIsEditing(false);
        onClose?.();
    };

    // helpers for rendering
    const renderValue = (value: string | undefined, fallback = "—") => value || fallback;


    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl mx-4 max-h-[85vh] overflow-y-auto">
                {/* Header Section */}
                <div className="p-4 border-b border-gray-200">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-2">
                            <div
                                className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center shadow-md">
                                <User className="h-6 w-6 text-white" />
                            </div>
                            <div>
                                <h3 className="text-xl font-bold text-gray-900">
                                    {selectedClient?.name}
                                </h3>
                                <span
                                    className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 mt-1">
                                    Standard Client
                                </span>
                            </div>
                        </div>
                        <div className="flex items-center space-x-2">
                            <button
                                onClick={onClose}
                                className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                            >
                                <X className="h-4 w-4 text-gray-400" />
                            </button>
                        </div>
                    </div>
                </div>

                {/* Stats Section */}
                <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
                        <div className="bg-white p-3 rounded-lg border border-gray-200 shadow-sm">
                            <div className="flex items-center space-x-2">
                                <div className="p-1.5 bg-green-100 rounded-md">
                                    <DollarSign className="h-4 w-4 text-green-600" />
                                </div>
                                <div>
                                    <p className="text-xs font-medium text-gray-600">Total Spent</p>
                                    <p className="text-lg font-bold text-green-600">
                                        {formatCurrency(selectedClient?.totalSpent || 0)}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white p-3 rounded-lg border border-gray-200 shadow-sm">
                            <div className="flex items-center space-x-2">
                                <div className="p-1.5 bg-blue-100 rounded-md">
                                    <TrendingUp className="h-4 w-4 text-blue-600" />
                                </div>
                                <div>
                                    <p className="text-xs font-medium text-gray-600">Total Visits</p>
                                    <p className="text-lg font-bold text-blue-600">
                                        {selectedClient?.visits || 0}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white p-3 rounded-lg border border-gray-200 shadow-sm">
                            <div className="flex items-center space-x-2">
                                <div className="p-1.5 bg-purple-100 rounded-md">
                                    <Calendar className="h-4 w-4 text-purple-600" />
                                </div>
                                <div>
                                    <p className="text-xs font-medium text-gray-600">Last Visit</p>
                                    <p className="text-sm font-semibold text-gray-900">
                                        {selectedClient?.lastVisit
                                            ? new Date(selectedClient.lastVisit).toLocaleDateString("en-US", {
                                                year: "numeric",
                                                month: "2-digit",
                                                day: "2-digit",
                                            })
                                            : "Never"}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white p-3 rounded-lg border border-gray-200 shadow-sm">
                            <div className="flex items-center space-x-2">
                                <div className="p-1.5 bg-orange-100 rounded-md">
                                    <User className="h-4 w-4 text-orange-600" />
                                </div>
                                <div>
                                    <p className="text-xs font-medium text-gray-600">Client Since</p>
                                    <p className="text-sm font-semibold text-gray-900">
                                        {selectedClient?.createdAt
                                            ? format(new Date(selectedClient.createdAt), "MM/dd/yyyy")
                                            : "—"}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main Content */}
                <div className="p-4">
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                        {/* Left Column - Personal Information */}
                        <div className="lg:col-span-2">
                            <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
                                <div className="p-4">
                                    <div className="flex items-center justify-between mb-4">
                                        <h4 className="text-base font-semibold text-blue-600 flex items-center">
                                            {/*<div*/}
                                            {/*    className="w-[100px] h-[100px] rounded-full overflow-hidden bg-zinc-100 flex items-center justify-center">*/}
                                            {/*    {profileImagePreview ? (*/}
                                            {/*        <img src={profileImagePreview} alt="preview"*/}
                                            {/*             className="object-cover w-full h-full"/>*/}
                                            {/*    ) : (*/}
                                            {/*        <User className="h-8 w-8 text-gray-400"/>*/}
                                            {/*    )}*/}
                                            {/*</div>*/}

                                            {/*{isEditing && (*/}
                                            {/*    <>*/}
                                            {/*        <input*/}
                                            {/*            id="profile-upload"*/}
                                            {/*            type="file"*/}
                                            {/*            accept="image/*"*/}
                                            {/*            className="hidden"*/}
                                            {/*            onChange={(e) => handleProfileImageChange(e)} // don't submitNow, updateClientBulk will call handleAvatarUpload*/}
                                            {/*        />*/}
                                            {/*        <label htmlFor="profile-upload"*/}
                                            {/*               className="text-sm cursor-pointer text-blue-600">Change*/}
                                            {/*            avatar</label>*/}
                                            {/*    </>*/}
                                            {/*)}*/}


                                            <User className="h-4 w-4 text-blue-600 mr-2" />
                                            Personal Information
                                        </h4>
                                        {isEditing ? (
                                            <div className="flex items-center space-x-2">


                                                <button onClick={handleSave} disabled={isCreatingClient}
                                                    className="px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-all duration-200 text-sm font-medium shadow-sm">
                                                    {isCreatingClient ? "Saving..." : "Save Changes"}
                                                </button>

                                                <button onClick={cancelEdit}
                                                    className="px-3 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-all duration-200 text-sm font-medium">
                                                    Cancel
                                                </button>

                                            </div>
                                        ) : (
                                            <button
                                                onClick={startEdit}
                                                className="flex items-center space-x-2 px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-all duration-200 text-sm font-medium shadow-sm"
                                            >
                                                <Edit className="h-4 w-4" />
                                                <span>Edit</span>
                                            </button>
                                        )}
                                    </div>

                                    {/* Name Section */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                First Name
                                            </label>

                                            {isEditing ? (
                                                <input
                                                    type="text"
                                                    value={editingClient?.firstName ?? ""}
                                                    onChange={(e) => setEditingClient((prev: any) => ({
                                                        ...(prev || {}),
                                                        firstName: e.target.value
                                                    }))}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                                                />
                                            ) : (
                                                <div className="px-3 py-2 bg-gray-50 rounded-md border border-gray-200">
                                                    <span
                                                        className="text-gray-900 font-medium">{(selectedClient?.name || "").split(" ")[0] || "—"}</span>
                                                </div>
                                            )}

                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                Last Name
                                            </label>

                                            {isEditing ? (
                                                <input
                                                    type="text"
                                                    value={editingClient?.lastName ?? ""}
                                                    onChange={(e) => setEditingClient((prev: any) => ({
                                                        ...(prev || {}),
                                                        lastName: e.target.value
                                                    }))}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                                                />
                                            ) : (
                                                <div className="px-3 py-2 bg-gray-50 rounded-md border border-gray-200">
                                                    <span
                                                        className="text-gray-900 font-medium">{(selectedClient?.name || "").split(" ").slice(1).join(" ") || "—"}</span>
                                                </div>
                                            )}


                                        </div>
                                    </div>

                                    {/* Contact Section */}
                                    <div className="mb-4">
                                        <h5 className="text-sm font-medium text-blue-600 mb-3 flex items-center">
                                            <Phone className="h-4 w-4 text-blue-600 mr-2" />
                                            Contact Information
                                        </h5>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    Email Address
                                                </label>
                                                {isEditing ? (
                                                    <input
                                                        type="email"
                                                        value={editingClient?.email ?? ""}
                                                        onChange={(e) =>
                                                            setEditingClient((prev: any) => ({
                                                                ...(prev || {}),
                                                                email: e.target.value,
                                                            }))
                                                        }
                                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                                                    />
                                                ) : (
                                                    <div
                                                        className="flex items-center px-3 py-2 bg-gray-50 rounded-md border border-gray-200">
                                                        <Mail className="h-4 w-4 text-gray-400 mr-2" />
                                                        <span className="text-gray-900">
                                                            {selectedClient?.email || "—"}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                                    Phone Number
                                                </label>
                                                {isEditing ? (
                                                    <input
                                                        type="tel"
                                                        value={editingClient?.phone ?? ""}
                                                        onChange={(e) =>
                                                            setEditingClient((prev: any) => ({
                                                                ...(prev || {}),
                                                                phone: e.target.value,
                                                            }))
                                                        }
                                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                                                    />
                                                ) : (
                                                    <div
                                                        className="flex items-center px-3 py-2 bg-gray-50 rounded-md border border-gray-200">
                                                        <Phone className="h-4 w-4 text-gray-400 mr-2" />
                                                        <span className="text-gray-900">
                                                            {selectedClient?.phone || "—"}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Managers */}
                                    {/*                                    <div className="mb-4">*/}
                                    {/*                                        <label className="block text-sm font-medium text-gray-700 mb-2">Managers</label>*/}
                                    {/*                                        {isEditing ? (*/}
                                    {/*        <Select*/}
                                    {/*            isMulti*/}
                                    {/*            value={(editingClient?.managerIds || []).map((id:number) => {*/}
                                    {/*                const emp = employees.find((e:any) => e.id === id);*/}
                                    {/*                return emp ? { value: emp.id, label: emp.name } : null;*/}
                                    {/*            }).filter(Boolean)}*/}
                                    {/*            onChange={(selectedOptions:any) => {*/}
                                    {/*                setEditingClient((prev:any) => ({ ...(prev || {}), managerIds: selectedOptions.map((s:any) => s.value) }));*/}
                                    {/*            }}*/}
                                    {/*            options={employees.map((e:any) => ({ value: e.id, label: e.name }))}*/}
                                    {/*            styles={{}} // or use reactSelectStyles if available*/}
                                    {/*        />*/}
                                    {/*    ) : (*/}
                                    {/*        <div className="px-3 py-2 bg-gray-50 rounded-md border border-gray-200">*/}
                                    {/*            {selectedClient?.managers?.map((m:any) => m.name).join(", ") || "—"}*/}
                                    {/*        </div>*/}
                                    {/*    )}*/}
                                    {/*</div>*/}

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div className="flex flex-col gap-2">
                                            <label className="text-sm text-neutral-500">
                                                Address
                                            </label>

                                            {isEditing ?
                                                <input
                                                    type="text"
                                                    name="address"
                                                    onChange={(e) =>
                                                        setEditingClient((prev: any) => ({
                                                            ...(prev || {}),
                                                            address: e.target.value,
                                                        }))
                                                    }
                                                    value={editingClient?.address}
                                                    required
                                                    placeholder="Enter Address"
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                />

                                                : <div
                                                    className="px-3 py-2 bg-gray-50 rounded-md border border-gray-200 min-h-[80px]">
                                                    <p className="text-gray-900 whitespace-pre-wrap">
                                                        {selectedClient?.address ? selectedClient?.address : ''}
                                                    </p>
                                                </div>}


                                        </div>
                                        <div className="flex flex-col gap-2">
                                            <label className="text-sm text-neutral-500">
                                                DOB
                                            </label>
                                            {isEditing ?
                                                <DatePicker
                                                    maxValue={today(getLocalTimeZone())}
                                                    name="dob"
                                                    value={
                                                        editingClient?.dob
                                                            ? parseDate(editingClient.dob)
                                                            : null
                                                    }
                                                    onChange={(date) => {
                                                        setEditingClient((prev: any) => ({
                                                            ...(prev || {}),
                                                            dob: date ? date.toString() : null, // ✅ "YYYY-MM-DD"
                                                        }));
                                                    }}
                                                /> : <div
                                                    className="px-3 py-2 bg-gray-50 rounded-md border border-gray-200 min-h-[80px]">
                                                    <p className="text-gray-900 whitespace-pre-wrap">
                                                        {selectedClient?.dob ? selectedClient?.dob : ''}
                                                    </p>
                                                </div>}

                                        </div>
                                    </div>

                                    {/* Notes Section */}
                                    <div>
                                        <h5 className="text-sm font-medium text-blue-600 mb-3">
                                            Notes
                                        </h5>
                                        <div>
                                            {isEditing ? (
                                                <textarea
                                                    rows={4}
                                                    value={editingClient?.notes ?? ""}
                                                    onChange={(e) =>
                                                        setEditingClient((prev: any) => ({
                                                            ...(prev || {}),
                                                            notes: e.target.value,
                                                        }))
                                                    }
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 resize-none"
                                                    placeholder="Add any special notes about this client..."
                                                />
                                            ) : (
                                                <div
                                                    className="px-3 py-2 bg-gray-50 rounded-md border border-gray-200 min-h-[80px]">
                                                    <p className="text-gray-900 whitespace-pre-wrap">
                                                        {selectedClient?.notes}
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Column - Order History */}
                        <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
                            <div className="space-y-3">
                                <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
                                    <div className="p-4">
                                        <div className="flex items-center justify-between mb-6">
                                            <h4 className="text-base font-semibold text-blue-600 flex items-center">
                                                <Package className="h-4 w-4 text-blue-600 mr-2" />
                                                Order History
                                            </h4>
                                        </div>
                                        <div className="space-y-3 max-h-[380px] overflow-y-auto pr-1">
                                            {isLoadingHistory ? (
                                                <div className="text-center py-8 text-sm text-gray-500">Loading orders...</div>
                                            ) : !sales || sales.length === 0 ? (
                                                <div className="text-center py-8 bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg border-2 border-dashed border-gray-300">
                                                    <Package className="h-12 w-12 text-gray-300 mx-auto mb-3" />
                                                    <p className="text-gray-500">No orders recorded yet</p>
                                                </div>
                                            ) : (
                                                sales.map((sale: any) => {
                                                    return (
                                                        <div key={sale.id} className="bg-gradient-to-r from-gray-50 to-gray-100 p-2.5 rounded-lg border border-gray-200 hover:shadow-md transition-all duration-200">
                                                            <div className="flex justify-between items-start">
                                                                <div className="space-y-1">
                                                                    <div className="flex items-center space-x-2">
                                                                        <span className="text-xs font-semibold text-gray-900">
                                                                            #{sale.id.toString().padStart(4, '0')}
                                                                        </span>
                                                                        <span className={`inline-flex px-1.5 py-0.5 text-[9px] font-semibold rounded-full uppercase ${sale.status === 'closed' ? 'bg-green-100 text-green-800' :
                                                                            sale.status === 'refunded' ? 'bg-red-100 text-red-800' :
                                                                                'bg-yellow-100 text-yellow-800'
                                                                            }`}>
                                                                            {sale.status}
                                                                        </span>
                                                                    </div>
                                                                    <div className="flex items-center space-x-2">
                                                                        <Calendar className="h-3 w-3 text-gray-400" />
                                                                        <p className="text-[10px] text-gray-500">
                                                                            {sale.createdAt || sale.created_at ? format(toLocalDate(sale.createdAt || sale.created_at, shopTimeZoneFromShops(shops)), "M/d/yyyy") : 'N/A'}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div className="flex items-center space-x-2">
                                                                    <span className="text-xs font-bold text-green-600">
                                                                        {typeof sale.total === 'string' && sale.total.includes('$') ? sale.total : formatCurrency(Number(sale.total) || 0)}
                                                                    </span>
                                                                    <button
                                                                        onClick={() => handleOpenTransactionDetails(sale.id)}
                                                                        className="p-1 text-gray-400 hover:text-blue-600 transition-colors"
                                                                    >
                                                                        <Eye className="h-3 w-3" />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {selectedSaleId && (
                <TransactionDetailsModal onClose={handleCloseTransactionDetails} />
            )}
        </div>
    );
};

export default ViewClientModal;


//
//
// import React, { useEffect, useState } from "react";
// import {
//     Calendar,
//     DollarSign,
//     Edit,
//     Mail,
//     Phone,
//     Package,
//     TrendingUp,
//     User,
//     X,
// } from "lucide-react";
// import { format } from "date-fns";
// import { useManageClients } from "../../useManageClients";
// import Select from "react-select";
//
// interface ViewClientModalProps {
//     onClose: () => void;
//     selectedClient: any;
// }
//
// const ViewClientModal: React.FC<ViewClientModalProps> = ({ onClose, selectedClient }) => {
//     const {
//         formatCurrency,
//         isCreatingClient,
//         setIsCreatingClient,
//         profileImagePreview,
//         setProfileImagePreview,
//         profileImageFile,
//         setProfileImageFile,
//         handleAvatarUpload,
//         handleProfileImageChange,
//         updateClientBulk, // new function added to the hook
//         employees,
//     } = useManageClients();
//
//     const [isEditing, setIsEditing] = useState(false);
//     const [editingClient, setEditingClient] = useState<any | null>(null);
//
//     useEffect(() => {
//         // whenever selectedClient changes, if not editing, keep UI showing selectedClient
//         if (!isEditing) setEditingClient(null);
//     }, [selectedClient, isEditing]);
//
//     const startEdit = () => {
//         const nameParts = (selectedClient?.name || "").split(" ");
//         setEditingClient({
//             id: selectedClient.id,
//             firstName: nameParts[0] || "",
//             lastName: nameParts.slice(1).join(" ") || "",
//             email: selectedClient.email || "",
//             phone: selectedClient.phone || "",
//             gender: selectedClient.gender || "non_binary",
//             managerIds: selectedClient.managers?.map((m: any) => m.id) || [],
//             notes: selectedClient.notes?.map((n: any) => n.content).join("\n") || "",
//             // copy any other fields you want editable
//         });
//         setIsEditing(true);
//     };
//
//     const cancelEdit = () => {
//         setIsEditing(false);
//         setEditingClient(null);
//     };
//
//     const handleSave = async () => {
//         if (!editingClient) return;
//         await updateClientBulk(editingClient);
//         // close edit mode and optionally refresh parent
//         setIsEditing(false);
//         // optionally you can call onClose(); or a fetch/refresh function here
//     };
//
//     // helpers for rendering
//     const renderValue = (value: string | undefined, fallback = "—") => value || fallback;
//
//     return (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//             <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl mx-4 max-h-[85vh] overflow-y-auto">
//                 <div className="p-4 border-b border-gray-200">
//                     <div className="flex items-center justify-between">
//                         <div className="flex items-center space-x-2">
//                             <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center shadow-md">
//                                 <User className="h-6 w-6 text-white" />
//                             </div>
//                             <div>
//                                 <h3 className="text-xl font-bold text-gray-900">{selectedClient?.name}</h3>
//                                 <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 mt-1">
//                   Standard Client
//                 </span>
//                             </div>
//                         </div>
//                         <div className="flex items-center space-x-2">
//                             {isEditing ? (
//                                 <>
//                                     <button onClick={handleSave} disabled={isCreatingClient} className="px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm">
//                                         {isCreatingClient ? "Saving..." : "Save Changes"}
//                                     </button>
//                                     <button onClick={cancelEdit} className="px-3 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 text-sm">
//                                         Cancel
//                                     </button>
//                                 </>
//                             ) : (
//                                 <button onClick={startEdit} className="flex items-center space-x-2 px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm">
//                                     <Edit className="h-4 w-4" /> <span>Edit</span>
//                                 </button>
//                             )}
//
//                             <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors">
//                                 <X className="h-4 w-4 text-gray-400" />
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//
//                 <div className="p-4">
//                     <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
//                         <div className="lg:col-span-2">
//                             <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
//                                 <div className="p-4">
//                                     {/* Name */}
//                                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//                                         <div>
//                                             <label className="block text-sm font-medium text-gray-700 mb-2">First Name</label>
//                                             {isEditing ? (
//                                                 <input
//                                                     type="text"
//                                                     value={editingClient?.firstName ?? ""}
//                                                     onChange={(e) => setEditingClient((prev:any) => ({ ...(prev || {}), firstName: e.target.value }))}
//                                                     className="w-full px-3 py-2 border border-gray-300 rounded-md"
//                                                 />
//                                             ) : (
//                                                 <div className="px-3 py-2 bg-gray-50 rounded-md border border-gray-200">
//                                                     <span className="text-gray-900 font-medium">{(selectedClient?.name || "").split(" ")[0] || "—"}</span>
//                                                 </div>
//                                             )}
//                                         </div>
//
//                                         <div>
//                                             <label className="block text-sm font-medium text-gray-700 mb-2">Last Name</label>
//                                             {isEditing ? (
//                                                 <input
//                                                     type="text"
//                                                     value={editingClient?.lastName ?? ""}
//                                                     onChange={(e) => setEditingClient((prev:any) => ({ ...(prev || {}), lastName: e.target.value }))}
//                                                     className="w-full px-3 py-2 border border-gray-300 rounded-md"
//                                                 />
//                                             ) : (
//                                                 <div className="px-3 py-2 bg-gray-50 rounded-md border border-gray-200">
//                                                     <span className="text-gray-900 font-medium">{(selectedClient?.name || "").split(" ").slice(1).join(" ") || "—"}</span>
//                                                 </div>
//                                             )}
//                                         </div>
//                                     </div>
//
//                                     {/* Contact */}
//                                     <div className="mb-4">
//                                         <h5 className="text-sm font-medium text-blue-600 mb-3 flex items-center">Contact Information</h5>
//                                         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                                             <div>
//                                                 <label className="block text-sm font-medium text-gray-700 mb-2">Email Address</label>
//                                                 {isEditing ? (
//                                                     <input
//                                                         type="email"
//                                                         value={editingClient?.email ?? ""}
//                                                         onChange={(e) => setEditingClient((prev:any) => ({ ...(prev || {}), email: e.target.value }))}
//                                                         className="w-full px-3 py-2 border border-gray-300 rounded-md"
//                                                     />
//                                                 ) : (
//                                                     <div className="flex items-center px-3 py-2 bg-gray-50 rounded-md border border-gray-200">
//                                                         <Mail className="h-4 w-4 text-gray-400 mr-2" /> <span>{renderValue(selectedClient?.email)}</span>
//                                                     </div>
//                                                 )}
//                                             </div>
//
//                                             <div>
//                                                 <label className="block text-sm font-medium text-gray-700 mb-2">Phone Number</label>
//                                                 {isEditing ? (
//                                                     <input
//                                                         type="tel"
//                                                         value={editingClient?.phone ?? ""}
//                                                         onChange={(e) => setEditingClient((prev:any) => ({ ...(prev || {}), phone: e.target.value }))}
//                                                         className="w-full px-3 py-2 border border-gray-300 rounded-md"
//                                                     />
//                                                 ) : (
//                                                     <div className="flex items-center px-3 py-2 bg-gray-50 rounded-md border border-gray-200">
//                                                         <Phone className="h-4 w-4 text-gray-400 mr-2" /> <span>{renderValue(selectedClient?.phone)}</span>
//                                                     </div>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     </div>
//
//                                     {/* Gender */}
//                                     <div className="mb-4">
//                                         <label className="block text-sm font-medium text-gray-700 mb-2">Gender</label>
//                                         {isEditing ? (
//                                             <div className="flex gap-4">
//                                                 <label className="flex items-center gap-2">
//                                                     <input type="radio" name="gender" value="female" checked={editingClient?.gender === "female"} onChange={() => setEditingClient((p:any)=>({...p, gender:"female"}))} /> Female
//                                                 </label>
//                                                 <label className="flex items-center gap-2">
//                                                     <input type="radio" name="gender" value="male" checked={editingClient?.gender === "male"} onChange={() => setEditingClient((p:any)=>({...p, gender:"male"}))} /> Male
//                                                 </label>
//                                                 <label className="flex items-center gap-2">
//                                                     <input type="radio" name="gender" value="non_binary" checked={editingClient?.gender === "non_binary"} onChange={() => setEditingClient((p:any)=>({...p, gender:"non_binary"}))} /> Non-binary
//                                                 </label>
//                                             </div>
//                                         ) : (
//                                             <div className="px-3 py-2 bg-gray-50 rounded-md border border-gray-200">
//                                                 {renderValue(selectedClient?.gender)}
//                                             </div>
//                                         )}
//                                     </div>
//
//                                     {/* Managers */}
//                                     <div className="mb-4">
//                                         <label className="block text-sm font-medium text-gray-700 mb-2">Managers</label>
//                                         {isEditing ? (
//                                             <Select
//                                                 isMulti
//                                                 value={(editingClient?.managerIds || []).map((id:number) => {
//                                                     const emp = employees.find((e:any) => e.id === id);
//                                                     return emp ? { value: emp.id, label: emp.name } : null;
//                                                 }).filter(Boolean)}
//                                                 onChange={(selectedOptions:any) => {
//                                                     setEditingClient((prev:any) => ({ ...(prev || {}), managerIds: selectedOptions.map((s:any) => s.value) }));
//                                                 }}
//                                                 options={employees.map((e:any) => ({ value: e.id, label: e.name }))}
//                                                 styles={{}} // or use reactSelectStyles if available
//                                             />
//                                         ) : (
//                                             <div className="px-3 py-2 bg-gray-50 rounded-md border border-gray-200">
//                                                 {selectedClient?.managers?.map((m:any) => m.name).join(", ") || "—"}
//                                             </div>
//                                         )}
//                                     </div>
//
//                                     {/* Notes */}
//                                     <div>
//                                         <label className="block text-sm font-medium text-gray-700 mb-2">Notes</label>
//                                         {isEditing ? (
//                                             <textarea
//                                                 rows={4}
//                                                 value={editingClient?.notes ?? ""}
//                                                 onChange={(e) => setEditingClient((prev:any) => ({ ...(prev || {}), notes: e.target.value }))}
//                                                 className="w-full px-3 py-2 border border-gray-300 rounded-md resize-y"
//                                                 placeholder="Add notes (one per line)"
//                                             />
//                                         ) : (
//                                             <div className="px-3 py-2 bg-gray-50 rounded-md border border-gray-200 min-h-[80px]">
//                                                 <p className="whitespace-pre-wrap">{selectedClient?.notes?.map((n:any) => n.content).join("\n") || "No notes"}</p>
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//
//                         {/* Right column: stats / avatar */}
//                         <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4">
//                             <div className="flex flex-col items-center gap-4">
//                                 <div className="w-[100px] h-[100px] rounded-full overflow-hidden bg-zinc-100 flex items-center justify-center">
//                                     {profileImagePreview ? (
//                                         <img src={profileImagePreview} alt="preview" className="object-cover w-full h-full" />
//                                     ) : (
//                                         <User className="h-8 w-8 text-gray-400" />
//                                     )}
//                                 </div>
//
//                                 {isEditing && (
//                                     <>
//                                         <input
//                                             id="profile-upload"
//                                             type="file"
//                                             accept="image/*"
//                                             className="hidden"
//                                             onChange={(e) => handleProfileImageChange(e)} // don't submitNow, updateClientBulk will call handleAvatarUpload
//                                         />
//                                         <label htmlFor="profile-upload" className="text-sm cursor-pointer text-blue-600">Change avatar</label>
//                                     </>
//                                 )}
//
//                                 <div className="w-full">
//                                     <div className="grid gap-3">
//                                         <div className="bg-white p-3 rounded-lg border border-gray-200">
//                                             <div className="flex items-center space-x-2">
//                                                 <div className="p-1.5 bg-green-100 rounded-md">
//                                                     <DollarSign className="h-4 w-4 text-green-600" />
//                                                 </div>
//                                                 <div>
//                                                     <p className="text-xs font-medium text-gray-600">Total Spent</p>
//                                                     <p className="text-lg font-bold text-green-600">{formatCurrency(selectedClient?.totalSpent || 0)}</p>
//                                                 </div>
//                                             </div>
//                                         </div>
//
//                                         <div className="bg-white p-3 rounded-lg border border-gray-200">
//                                             <div className="flex items-center space-x-2">
//                                                 <div className="p-1.5 bg-blue-100 rounded-md">
//                                                     <TrendingUp className="h-4 w-4 text-blue-600" />
//                                                 </div>
//                                                 <div>
//                                                     <p className="text-xs font-medium text-gray-600">Total Visits</p>
//                                                     <p className="text-lg font-bold text-blue-600">{selectedClient?.visits || 0}</p>
//                                                 </div>
//                                             </div>
//                                         </div>
//
//                                         <div className="bg-white p-3 rounded-lg border border-gray-200">
//                                             <div className="flex items-center space-x-2">
//                                                 <div className="p-1.5 bg-purple-100 rounded-md">
//                                                     <Calendar className="h-4 w-4 text-purple-600" />
//                                                 </div>
//                                                 <div>
//                                                     <p className="text-xs font-medium text-gray-600">Client Since</p>
//                                                     <p className="text-sm font-semibold text-gray-900">{selectedClient?.createdAt ? format(new Date(selectedClient.createdAt), "MM/dd/yyyy") : "—"}</p>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//
//                             </div>
//                         </div>
//
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };
//
// export default ViewClientModal;

